<template>
  <service-screen-layout :parts="parts">
    <template v-slot:line>
      <div class="col-md-12">
        <ConnectivityLine 
          :line="saleDefinition.definition.line" 
          @saveSale="saveSale"
        />
      </div>
    </template>
    <template v-slot:router v-if="saleNumber">
      <div class="row">
        <div class="col-md-12">
          <RouterConfig
            :routerConfig="saleDefinition.definition.routerConfig"
            :saleNumber="saleNumber"
            :showDocumentation="false"
            @routerConfigSaved="routerConfigSavedHandler"
            @reloadSale="reloadSaleDefinition"
          />
        </div>
      </div>
    </template>
    <template v-slot:additionalbilling>
        <AdditionalBillingComponent
          v-allowed:view="['STAFF', 'CLIENT', 'RESELLER', 'SYSTEM']"
          :selectablepackages="saleDefinition.selectableOptions.additionalBillingPackage"
          :billingitems="saleDefinition.definition.additionalBilling"
          :saleDefinition="saleDefinition" 
          :emptyBillingComponent="emptyAdditionalBilling"
          :availableperiods="availablePeriods"
          @reloadSale="reloadSaleDefinition"
        />
    </template>
  </service-screen-layout>
</template>

<script>
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import ConnectivityLine from "@/components/ObjParts/SingleCaptured/ConnectivityLine";
import RouterConfig from "@/components/ObjParts/OptionalCaptured/RouterConfig";
import AdditionalBillingComponent from "@/components/ObjParts/MultipleCaptured/AdditionalBillingComponent";
import SaleFunctions from "@/pages/Services/SaleFunctions";

export default {
  extends: SaleFunctions,
  components: {
    ServiceScreenLayout,
    ConnectivityLine,
    RouterConfig,
    AdditionalBillingComponent
  },
  data() {
    return {
      saleNumber: null,
      parts: [
        {
          name: "line",
          icon: "fa fa-link",
          displayName: "Line",
          permissions: ["*"],
        },
        {
          name: "router",
          icon: "fa fa-cogs",
          displayName: "Router",
          permissions: ["STAFF"],
        },
        {
          name: "additionalbilling",
          icon: "fa fa-link",
          displayName: "Additional Billing",
          permissions: ["*"],
        },

      ],
      saleDefinition: {
        sale: {},
        definition: {
          routerConfig: {},
          uncappedService: {},
          line: {
            lineOrder: {
              status: ""
            },
            lineAddress: {},
          },
        },
        selectableOptions: {
          additionalBillingPackage: [],
        },
      },
      emptyAdditionalBilling: {},
      availablePeriods: [],
    };
  },
  async mounted() {
    this.saleNumber = Number(this.$route.params.saleNumber);
    this.reloadSaleDefinition();
  },
  methods: {
    reloadSaleDefinition() {
      this.getSaleDefinition(this.saleNumber).then(
        (success) => {
          this.saleDefinition = success.data;
          this.getEmptyAdditionalBilling();
          this.getAvailablePeriods();
        },
        (error) => {
          console.error(error);
          this.showError("Error Fetching Sale Definition", error);
        }
      );
    },
    getEmptyAdditionalBilling: function() {
        this.$http.get(this.$config.aimsAPI + "connectivityaccounts/empty/additionalbillingcomponent/" + this.saleDefinition.sale.saleNumber).then(
            (response) => {
                this.emptyAdditionalBilling = response.data; 
            },
            (error) => {
                console.error(error);
                this.showError("Error fetching empty Additional Package", error);
            }
        );
    },
    getAvailablePeriods: function() {
      let availablePeriods = [];
      const hostUrl = this.$config.aimsAPI;
      this.$http.get(`${hostUrl}connectivityaccounts/availableperiods`).then(
        (response) => {
            this.availablePeriods = availablePeriods.concat(response.data);
          },
          (error) => {
            this.showError("Error fetching periods for Additional Billing", error);
            console.error(error);
          }
        );
    },
    saveSale() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .put(
              this.$config.aimsAPI +
                "sales/definition/" +
                this.saleDefinition.sale.saleNumber +
                "/update",
              this.saleDefinition
            )
            .then(
              (response) => {
                this.showSuccess("Save Success");
                this.saleDefinition = response.data;
              },
              (error) => {
                console.error(error);
                this.showError("Error Saving Pppoe Account", error);
              }
            );
        }
      });
    },
    routerConfigSavedHandler(routerConfig) {
      this.saleDefinition.definition.routerConfig = routerConfig;
      this.saveSale();
    },
  },
};
</script>
